'use strict';
const angular = require('angular');

export default angular.module('appApp.handsontable', [])
  .directive('handsontable', function() {
    return {
      template: require('./handsontable.html'),
      restrict: 'EA',
      link: function(scope, element, attrs) {}
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/handsontable/handsontable.directive.js